import { Document, Page, View, Text, StyleSheet } from '@react-pdf/renderer';
import type { InventoryLot } from '../../types/inventory';
import type { GreenBeanProfile } from '../../types/greenBean';
import { LABEL_SIZE, labelStyles, dash } from './labelStyles';
import { QrImage } from './labelPrimitives';

interface LotLabelDocumentProps {
  lot: InventoryLot;
  profile: GreenBeanProfile | null;
  qrDataUrl: string;
}

/** Format an ISO date; fall back to the raw string (e.g. a bare harvest year), else "-". */
const formatDate = (value?: string): string => {
  if (!value) return '-';
  const d = new Date(value);
  if (!Number.isNaN(d.getTime())) return d.toLocaleDateString();
  return dash(value);
};

const lotLabelStyles = StyleSheet.create({
  page: { alignItems: 'flex-start' },
  info: { justifyContent: 'flex-start' },
  title: { textAlign: 'left' },
  line: { textAlign: 'left' },
});

export const LotLabelDocument: React.FC<LotLabelDocumentProps> = ({ lot, profile, qrDataUrl }) => {
  const origin = dash(profile?.region || profile?.country);
  const moisture = profile?.moisture_content != null ? `${profile.moisture_content}%` : '-';
  return (
    <Document>
      <Page size={LABEL_SIZE} style={[labelStyles.page, lotLabelStyles.page]}>
        <QrImage src={qrDataUrl} />
        <View style={[labelStyles.info, lotLabelStyles.info]}>
          <Text style={[labelStyles.title, lotLabelStyles.title]}>LOT: {dash(lot.lotNumber)}</Text>
          <Text style={[labelStyles.line, lotLabelStyles.line]}>{dash(profile?.process_type)} | {origin}</Text>
          <Text style={[labelStyles.line, lotLabelStyles.line]}>
            {dash(lot.supplierName)} | {formatDate(profile?.harvest_date)} | {formatDate(lot.receivedDate)}
          </Text>
          <View style={labelStyles.gap} />
          <Text style={[labelStyles.line, lotLabelStyles.line]}>{dash(profile?.density)} | {moisture}</Text>
          <View style={labelStyles.gap} />
          <Text style={[labelStyles.line, lotLabelStyles.line]}>Grade {dash(profile?.grade)}</Text>
        </View>
      </Page>
    </Document>
  );
};
